<template>
  <div>

      <h5>お気に入りピアノ / 販売者</h5>
      <div class="text-right my-2">
        <template v-if="String(display) == '1'">
          <span class="">ピアノ</span>
          <span class="px-2">/</span>
          <a style="color: #4170ff!important;" @click="display = 2" class="">販売者</a>
        </template>
        <template v-else>
          <a style="color: #4170ff!important;" @click="display = 1" class="">ピアノ</a>
          <span class="px-2">/</span>
          <span class="">販売者</span>
        </template>
      </div>
      <hr>
      <div class="py-3 contents">
        <template v-if="String(display) == '1'">
          <div v-for="(product, index) in allGetProducts">
            <div class="card col-md-12 pl-0 pr-0 m-0 mb-2">
              <div class="card-body row p-2 m-0">
                <div class="col-md-5 p-2 m-0" style="display: flex;align-items: center;justify-content: center;">
                  <img class="" :src="product['image1']" style="width: 80%;height: auto;">
                </div>
                <div class="card col-md-7 pl-0 pr-0 m-0" style="position: relative;">
                  <div class="card-body">
                    <h5 class="font-weight-bold p-0 m-0 mb-3">{{ product['title'] }}</h5>
                    <p class="card-text mb-3">
                      <span class="">{{ product['strong_point'] }}</span>
                    </p>
                    <p class="card-text mb-3" style="color: red;">価格(税抜):　{{ String(product['price']).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') }}円</p>
                    <p class="card-text m-0 d-flex">販売者:　
                      <span class="mr-2" v-if="product['legal_person']==1">{{ product['corp_name'] }}</span>
                      <span class="mr-2" v-if="product['legal_person']==0">{{ product['store_name'] }}</span>
                      <star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="product['evaluation']"></star-rating>
                    </p>
                    <p class="card-text m-0">掲載日:　{{ date_only_format(product['opened_at']) }}</p><!-- YYYY年MM月DD日 -->
                    <p class="card-text m-0">ブランド:　{{ get_hash_value(brand, product['brand']) }}</p>
                    <p class="card-text m-0">型番:　{{ cinit(product['model_number'], "-") }}</p>
                    <p class="card-text m-0">外装:　{{ get_hash_value(color, product['color']) }}／{{ cinit(product['exterior_finish'], "-") }}</p>
                    <p class="card-text m-0">展示（保管）場所:　{{ cinit(product['storage_location'], "-") }}</p>
                    <button @click="jumpDetail(product['id'])" style="position: absolute;bottom: 50px;right: 20px;width: 80px;" class="btn btn-primary">詳細</button>
                    <button @click="updFavorite(product['id'], product['users_id'])" style="position: absolute;bottom: 10px;right: 20px;width: 80px;" class="btn btn-primary">
                        <span class="heart" v-if="product['favorite']">♥</span>
                        <span class="heart" v-else>♡</span>
                        <span class="pl-3">{{ product['favorite_count'] }}</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="page" v-show="all_products.length>0">
            <vuejs-paginate
              :page-count="allGetPageCountProduct"
              :page-range="3"
              :margin-pages="2"
              :click-handler="allClickCallbackProduct"
              :prev-text="'＜'"
              :next-text="'＞'"
              :container-class="'pagination'"
              :page-class="'page-item'">
            </vuejs-paginate>
          </div>
        </template>
        <template v-else>
          <div v-for="(seller, index) in allGetSellers">
            <div class="card col-md-12 pl-0 pr-0 m-0 mb-2">
              <div class="card-body row p-2 m-0">
                <div class="col-md-5 p-2 m-0" style="display: flex;align-items: center;justify-content: center;">
                  <img class="" :src="seller['image1']" style="width: 80%;height: auto;">
                </div>
                <div class="card col-md-7 pl-0 pr-0 m-0" style="position: relative;">
                  <div class="card-body">
                    <div style="position: relative;">
                      <div class="d-flex">
                        <strong class="mr-2" v-if="seller['legal_person']==1">{{ seller['corp_name'] }}</strong>
                        <strong class="mr-2" v-if="seller['legal_person']==0">{{ seller['store_name'] }}</strong>
                        <star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="seller['evaluation']"></star-rating>
                      </div>
                      <p class="card-text mb-3">{{ seller['slogan'] }}</p>
                      <p class="card-text mb-3">ピアノ販売数　{{ seller['sell_num'] }}人</p>
                      <button @click="jumpSellerDetail(seller['id'])" style="position: absolute;bottom: 0px;right: 0px;width: 80px;" class="btn btn-primary">詳細</button>
                    </div>
                    <hr>
                    <div>
                      <p>{{ seller['region'] + ': ' + seller['address_1'] }}</p>
                      <p v-if="seller['whether_pay_installments']==1">ローン返済可能</p>
                      <p v-if="seller['whether_pay_installments']==2">ローン返済不可</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="page" v-show="all_sellers.length>0">
            <vuejs-paginate
              :page-count="allGetPageCountSeller"
              :page-range="3"
              :margin-pages="2"
              :click-handler="allClickCallbackSeller"
              :prev-text="'＜'"
              :next-text="'＞'"
              :container-class="'pagination'"
              :page-class="'page-item'">
            </vuejs-paginate>
          </div>
        </template>

      </div>
  </div>
</template>

<script>
import StarRating from 'vue-star-rating'
import VueJsPaginate from "vuejs-paginate";

export default {
  components: {
    'star-rating': StarRating,
    'vuejs-paginate': VueJsPaginate,
  },
  props: { 
    user: Object
  },
  data() {
		const status = [
      {"no":"0","name":"下書き"},
      {"no":"1","name":"出品中"},
      {"no":"2","name":"公開停止中"},
      {"no":"3","name":"売却済み"},
    ];
		const sort = [
      {"no":"1","name":"登録日の古い順"},
      {"no":"2","name":"登録日の新しい順"},
      {"no":"3","name":"価格の低い順"},
      {"no":"4","name":"価格の高い順"},
      {"no":"5","name":"お気に入りの多い順"},
      {"no":"6","name":"コメントの多い順"},
      {"no":"7","name":"表示の多い順"},
    ];
		const state = [
      {"no":"1","name":"新古品"},
      {"no":"2","name":"中古品（非常に良い）"},
      {"no":"3","name":"中古品（良い）"},
      {"no":"4","name":"中古品（あまり良くない）"},
      {"no":"5","name":"中古品（悪い）"},
    ];
		const type = [
      {"no":"1","name":"グランドピアノ（GP）"},
      {"no":"2","name":"アップライトピアノ（UP）"},
    ];
		const brand = [
      {"no":"1","name":"ヤマハ（YAMAHA）"},
      {"no":"2","name":"カワイ（KAWAI）"},
      {"no":"3","name":"スタインウェイ・アンド・サンズ　（Steinway&Sons）"},
      {"no":"4","name":"ベーゼンドルファー　（Bösendorfer）"},
      {"no":"5","name":"ベヒシュタイン　（BECHSTEIN）"},
      {"no":"6","name":"ボストン　（BOSTON）"},
      {"no":"7","name":"ディアパソン　（DIAPASON）"},
      {"no":"8","name":"アポロ　（APOLLO）"},
      {"no":"9","name":"国産ピアノ"},
      {"no":"10","name":"輸入ピアノ"},
    ];
		const color = [
      {"no":"1","name":"黒"},
      {"no":"2","name":"木目"},
      {"no":"3","name":"白"},
      {"no":"4","name":"その他"},
    ];
    return {
      display: 1, // 1:ピアノ 2:販売者
      status,
      sort,
      state,
      type,
      brand,
      color,

			all_products: [],
			all_parPage_product: 5,
			all_currentPage_product: 1,

      all_sellers: [],
			all_parPage_seller: 5,
			all_currentPage_seller: 1,

    }
  },
  methods: {
    searchFavorite() {
      this.get_favorite_info();
      return false;
    },
		async get_favorite_info() {
			this.$store.dispatch('user/get_favorite_info', {
        // type: this.searchForm.type,
        // sort: this.searchForm.sort,
      }).then(res => {
				console.log(res);
				this.all_products = res.data.products;
				this.all_sellers = res.data.sellers;
				console.log(this.all_products);
				console.log(this.all_sellers);
				// this.productCount = this.all_products.length;
			}, error => {
				console.log('error発生');
				console.log(error);
				this.$nextTick(() => {
          window.scrollTo({
            top: 0,
          });
				});
			});
		},
		allClickCallbackProduct: function (pageNum) {
      this.all_currentPage_product = Number(pageNum);
			this.$nextTick(() => {
				window.scrollTo({
					top: 0,
				});
			});
    },
		allClickCallbackSeller: function (pageNum) {
      this.all_currentPage_seller = Number(pageNum);
			this.$nextTick(() => {
				window.scrollTo({
					top: 0,
				});
			});
    },
	  jumpDetail: function(id){
        this.$router.push({path: '/product/'+String(id)});
	  },
    jumpSellerDetail: function(id){
        this.$router.push({path: '/seller/'+String(id)});
	  },
	  updFavorite(pid, sid) {
      this.upd_favorite(pid, sid);
      return false;
	  },
    // お気に入り更新処理
    async upd_favorite(pid, sid) {
      this.$store.dispatch('product/upd_favorite', {
        type: 1,
        products_id: pid,
        sellers_id: sid,
      //   users_id: this.,
      }).then(res => {
        console.log(res);
        for (let i = 0; i < this.all_products.length; i++) {
          if ( this.all_products[i]['id'] == pid && this.all_products[i]['users_id'] == sid ) {
            this.all_products[i]['favorite'] = !this.all_products[i]['favorite'];
            if(this.all_products[i]['favorite']){
              this.all_products[i]['favorite_count']++;
            }else {
              this.all_products[i]['favorite_count']--;
            }
          }
        }
        return false;
      }, error => {
        // バックエンドからエラーが返却された場合、ひとまずアラートでメッセージを出力
        console.log(error.response.data);
        if ('error' in error.response.data) {
          alert(error.response.data['error']);
          window.scrollTo({
            top: 0,
          });
        }
      });
      return false;
    },
  },
	computed: {
		allGetProducts: function() {
			let current = this.all_currentPage_product * this.all_parPage_product;
			let start = current - this.all_parPage_product;
			return this.all_products.slice(start, current);
		},
		allGetPageCountProduct: function() {
			return Math.ceil(this.all_products.length / this.all_parPage_product);
		},
		allGetSellers: function() {
			let current = this.all_currentPage_seller * this.all_parPage_seller;
			let start = current - this.all_parPage_seller;
			return this.all_sellers.slice(start, current);
		},
		allGetPageCountSeller: function() {
			return Math.ceil(this.all_sellers.length / this.all_parPage_seller);
		},
	},
  created() {
    this.searchFavorite();
  },

}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/mypage/buyer/favorite.vue